import { DomEventsSubscribe } from "../../events/dom-events-subscribe";
import { StringHelpers } from "../../helpers/string-helpers";
import { IChartContainer } from "../../models/base/chart-container.interface";
import { ChartRequirementModel } from "../../models/chart-requirement/chart-requirement.model";
import { IComponent } from "../component.interface";

export class BuyButtonComponent implements IComponent {
    public id = StringHelpers.newGuid();

    private element: HTMLElement;
    private base: IChartContainer;
    private domEvents: DomEventsSubscribe;
    private chartRequirement = new ChartRequirementModel();
    private plotLineActive = false;
    private requestingBuy = false;

    constructor(el: HTMLElement, base: IChartContainer) {
        this.element = el;
        this.base = base;
        this.domEvents = base.domEvents;
        this.onMouseMove();
        this.onMouseDown();
        this.onMouseEnter();
        this.onMouseLeave();
        this.onClick();
        this.onEscPress();
        this.onContextMenuOpen();
        this.subscribeChartRequirmentData();
        this.subscribeAllowBuyData();
    }

    private onMouseMove() {
        this.domEvents.onMouseMove(this.id, (event: MouseEvent) => {
            if (!this.base.tiChartSeries || !this.base.tiChartSeries.highStockChart || !this.plotLineActive) {
                return;
            }

            const yAxis = this.base.tiChartSeries.highStockChart.yAxis[0];
            if (!yAxis) {
                return;
            }

            const pointer = this.base.tiChartSeries.highStockChart.pointer.normalize(event);
            const parentElementRect = this.base.tiChartSeries.chartElement.getBoundingClientRect();
            const yTop = pointer.y - parentElementRect.y;

            const yValue = yAxis.toValue(yTop);
            yAxis.removePlotLine('buy-plot-line');
            yAxis.addPlotLine({
                value: yValue,
                id: 'buy-plot-line',
                className: 'buy-plot-line',
                zIndex: 10
            });
        });
    }

    private onMouseDown() {
        this.domEvents.onMouseDown(this.id, (event: MouseEvent) => {
            if (!this.base.tiChartSeries) {
                return;
            }

            if (!this.base.tiChartSeries.highStockChart || !this.plotLineActive || event.which == 3) {
                if (event.which == 3) {
                    this.inActivePlotLine();
                }

                return;
            }

            const yAxis = this.base.tiChartSeries.highStockChart.yAxis[0];
            if (!yAxis) {
                return;
            }
            
            const pointer = this.base.tiChartSeries.highStockChart.pointer.normalize(event);
            const parentElementRect = this.base.tiChartSeries.chartElement.getBoundingClientRect();
            const yTop = pointer.y - parentElementRect.y;

            const yValue = yAxis.toValue(yTop);
            this.base.chartService.requestInitiateChartTrade(yValue, true);
            
            this.inActivePlotLine();
        });
    }

    private onMouseEnter() {
        this.element.addEventListener('mouseenter', () => {
            this.base.chartService.requestBuySellButtonsHover(true, false);
        });
    }

    private onMouseLeave() {
        this.element.addEventListener('mouseleave', () => {
            this.base.chartService.requestBuySellButtonsHover(false, false);
        });
    }

    private onClick() {
        this.element.addEventListener('click', () => {
            this.requestingBuy = true;
            this.base.chartService.requestBuy();
        });
    }

    private onEscPress() {
        this.domEvents.onEscPress(this.id, () => {
            this.inActivePlotLine();
        });
    }

    private onContextMenuOpen() {
        this.domEvents.onContextMenu(this.id, () => {
            this.inActivePlotLine();
        });
    }

    private inActivePlotLine() {
        if (!this.base.tiChartSeries) {
            return;
        }
        if (this.plotLineActive) {
            const yAxis = this.base.tiChartSeries.highStockChart.yAxis[0];
            yAxis?.removePlotLine('buy-plot-line');
            this.plotLineActive = false;
        }
    }

    private addPlotLine() {
        if (!this.base.tiChartSeries) {
            return;
        }
        const yAxis = this.base.tiChartSeries.highStockChart.yAxis[0];
        if (!yAxis) {
            return;
        }

        if (this.plotLineActive) {
            yAxis.removePlotLine('buy-plot-line');
        } else {
            this.plotLineActive = true;
            yAxis.addPlotLine({
                value: 0,
                id: 'buy-plot-line',
                className: 'buy-plot-line',
                zIndex: 10
            });
        }
    }

    private subscribeChartRequirmentData() {
        this.base.chartService.subscribeChartRequirementsData((model: ChartRequirementModel) => {
            this.chartRequirement = model;
            this.toggleButton();
        });
    }

    private subscribeAllowBuyData() {
        this.base.chartService.subscribeChartAllowBuyData(() => {
            if (!this.requestingBuy) {
                return;
            }
            
            this.requestingBuy = false;
            this.addPlotLine();
        });
    }

    private toggleButton() {
        if (this.chartRequirement.allLongRequirements) {
            this.element.removeClass('disabled');
            this.element.setAttribute('title', 'Buy with ' + this.chartRequirement.longAccountName);
        } else {
            this.element.addClass('disabled');
            this.element.setAttribute('title', 'Click to initiate buy');
        }
    }
}